import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../lib/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { HiEye, HiEyeOff } from "react-icons/hi";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "The Only Consultant";
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            console.log("Login successful");
            navigate("/tax-help");
        } catch (err) {
            console.error("Login Error:", err);
            setError("Invalid email or password. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full max-w-full sm:max-w-[500px] min-h-screen md:min-h-[550px] flex-col bg-pink-50 flex items-center mx-auto">
            {/* Header */}
            <div className="w-full bg-[#f7adc4] text-white flex flex-col items-center px-2 sm:px-4 py-2 sm:py-4">
                <div className="w-full flex items-center justify-between mb-2">
                    <div className="w-6 sm:w-12"></div>
                    <h1 className="font-semibold tracking-wide text-base sm:text-xl md:text-[25px] text-center">
                        Tax Help, Made Simple
                    </h1>
                    <div className="w-6 sm:w-12"></div>
                </div>
                <img src="/1.png" alt="Logo" className="h-auto w-full max-w-[120px] sm:max-w-[150px] md:max-w-[180px]" />
            </div>

            <div className="w-full px-2 sm:px-4 py-3 sm:py-6">
                <div className="bg-[#f3ebe3] rounded-md shadow-xl border border-gray-300 overflow-hidden">
                    <div className="w-full flex items-center justify-center px-3 pt-4 sm:pt-6">
                        <h2 className="font-semibold text-center text-base sm:text-lg md:text-[20px] tracking-wide text-gray-800">
                            WELCOME BACK
                        </h2>
                    </div>

                    <div className="p-4 sm:p-6 md:p-8 flex flex-col space-y-4 sm:space-y-6">
                        {error && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded text-xs text-center">
                                {error}
                            </div>
                        )}
                        <form className="w-full" onSubmit={handleSubmit}>
                            <div className="space-y-0">
                                <input
                                    type="email"
                                    required
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full border border-gray-300 bg-white rounded-t-md rounded-b-none px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-500 focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all border-b-0"
                                    disabled={loading}
                                />
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        required
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full border border-gray-300 bg-white rounded-b-md rounded-t-none px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-500 focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all pr-10"
                                        disabled={loading}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#f7adc4] focus:outline-none"
                                    >
                                        {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                    </button>
                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className={`w-full bg-[#f7adc4] text-white tracking-widest rounded-full text-sm font-bold py-3 mt-2 hover:bg-[#f49fb8] transition-all transform active:scale-[0.98] shadow-md ${loading ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                            >
                                {loading ? "LOGGING IN..." : "LOGIN"}
                            </button>
                        </form>

                        <div className="text-center">
                            <p className="text-xs text-gray-600">
                                Don't have an account?{" "}
                                <Link
                                    to="/signup"
                                    className="font-bold text-[#f7adc4] hover:text-[#f49fb8] transition-colors"
                                >
                                    Create account
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="w-full bg-[#f7adc4] text-white text-center flex justify-center items-center px-4 py-2 mt-auto">
                <img src="/1.png" alt="Logo" className="h-auto w-16 sm:w-20" />
            </div>
        </div>
    );
};

export default Login;
